module.exports = __webpack_public_path__ + "img/LOGO-1.dc34d11b.png";